<template>
  <div class="reserve-container">
    <div class="reserve-container_ cen">
      <div class="inside-main">
        <div class="reserve-main">
          <div class="volunteer-detail-item">预约信息</div>
          <div class="reserve-table">
            <div class="reserve-thead">
              <div class="reserve-thead-li">预约内容</div>
              <div class="reserve-thead-li">预约时间</div>
              <div class="reserve-thead-li">接受服务人</div>
              <div class="reserve-thead-li">状态</div>
            </div>
            <div class="reserve-thead-mobile">预约内容</div>
            <div class="reserve-body">
              <div class="reserve-row" v-for="(item, index) in list" :key="index">
                <div class="reserve-row-li alignleft"><span>【{{item.service_type}}】{{item.title}}</span></div>
                <div class="reserve-row-li reserve-row-date"><span>{{item.posttime}}</span></div>
                <div class="reserve-row-li reserve-row-name"><span>{{item.service_name}}</span></div>
                <div class="reserve-row-li"><span class="colr">预约成功</span></div>
              </div>
            </div>
          </div>
          <div class="reserve-page" v-if="totalsPage > 1">
            <div class="reserve-page-prev" :class="[ page == 1 ? 'unclick' : '' ]" @click="prevPage">上一页</div>
            <div class="reserve-page-next" :class="[ page == totalsPage ? 'unclick' : '' ]" @click="nextPage">下一页</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">我的首页</div>
            <div class="enname">Member Center</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li">
              <router-link to="/member/index" class="left-nav-link">
                <div class="chname">基本信息</div>
                <div class="enname">Basic Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/security" class="left-nav-link">
                <div class="chname">个人安全信息</div>
                <div class="enname">Personal Safety Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/member/reserve" class="left-nav-link">
                <div class="chname">预约信息</div>
                <div class="enname">Reservation information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/family" class="left-nav-link">
                <div class="chname">我的家庭</div>
                <div class="enname">My Family</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHeaderData, getReserveData } from '../../api/getData.js'
export default {
  name: 'reserve',
  data () {
    return {
      headerInfo: {},
      page: 1,
      totals: 0,
      totalsPage: 1,
      list: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  created () {
    this.getHeaderInfo()
    this.getReserveInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'member', activeSendMenu: 'reserve' }).then(() => {}).catch(() => {})
    },
    async getReserveInfo () {
      let postData = {}
      postData.id = this.getUserId
      postData.p = this.page
      let result = await getReserveData(postData)
      this.list = result.reservelist
      this.totals = result.totalnum
      this.totalsPage = Math.ceil(result.totalnum / 5)
    },
    async prevPage () {
      if (this.page === 1) {
        return false
      }
      this.page = this.page - 1
      this.getReserveInfo()
    },
    async nextPage () {
      if (this.page === this.totalsPage) {
        return false
      }
      this.page = this.page + 1
      this.getReserveInfo()
    }
  }
}
</script>

<style scoped lang="less">
  .reserve-container_{
    padding: 40px 0 60px;
  }
  .reserve-main{
    width: 77.22%;
    padding: 0 60px 30px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #eb6420;
      margin-top: 60px;
      padding-left: 25px;
      font-size: 30px;
      line-height: 30px;
      color: #eb6420;
    }
    .reserve-table{
      margin-top: 32px;
      .reserve-thead{
        border-top: 1px solid #dcdcdc;
        border-left: 1px solid #dcdcdc;
        overflow: hidden;
        .reserve-thead-li{
          float: left;
          width: 25%;
          height: 59px;
          border-bottom: 1px solid #dcdcdc;
          border-right: 1px solid #dcdcdc;
          background-color: #f1f8f7;
          font-size: 24px;
          line-height: 58px;
          text-align: center;
          color: #333333;
        }
      }
      .reserve-thead-mobile{
        display: none;
        width: 100%;
        height: 30px;
        border: 1px solid #dcdcdc;
        background-color: #f1f8f7;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        color: #333333;
      }
      .reserve-body{
        .reserve-row{
          overflow: hidden;
          border-left: 1px solid #dcdcdc;
          .reserve-row-li{
            float: left;
            width: 25%;
            height: 79px;
            padding: 0 10px;
            border-bottom: 1px solid #dcdcdc;
            border-right: 1px solid #dcdcdc;
            font-size: 20px;
            line-height: 78px;
            text-align: center;
            color: #4879bd;
            &.alignleft{
              text-align: left;
            }
            .colr{
              color: #ec6420;
            }
          }
        }
      }
    }
    .reserve-page{
      width: 200px;
      height: 50px;
      margin: 30px auto 0;
      div{
        width: 80px;
        height: 100%;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        font-size: 16px;
        line-height: 48px;
        text-align: center;
        color: #333333;
        cursor: pointer;
        transition: all 0.5s ease 0s;
        &.unclick{
          color: #aaaaaa;
          cursor: not-allowed;
        }
        &:hover{
          background-color: #eb6420;
          color: #ffffff;
        }
        &.unclick:hover{
          background-color: transparent;
          color: #aaaaaa;
        }
      }
      .reserve-page-prev{
        float: left;
      }
      .reserve-page-next{
        float: right;
      }
    }
  }
  .inside-left-nav{
    padding-bottom: 150px;
  }
  @media screen and (max-width: 1580px){
    .reserve-container_{
      padding: 40px 30px 60px;
    }
  }
  @media screen and (max-width: 1200px){
    .reserve-container_{
      padding: 25px 10px 5px;
    }
    .reserve-main{
      width: 100%;
      margin-bottom: 20px;
      padding: 30px 10px 15px;
      border-radius: 3px;
      .volunteer-detail-item{
        border-left: 2px solid #eb6420;
        margin-top: 0;
        margin-left: 5px;
        padding-left: 9px;
        font-size: 15px;
        line-height: 15px;
      }
      .reserve-table{
        margin-top: 10px;
        .reserve-thead{
          display: none;
        }
        .reserve-thead-mobile{
          display: block;
        }
        .reserve-body{
          .reserve-row{
            overflow: hidden;
            padding: 14px 10px 10px;
            border-left: 1px solid #dcdcdc;
            border-right: 1px solid #dcdcdc;
            border-bottom: 1px solid #dcdcdc;
            .reserve-row-li{
              float: none;
              width: auto;
              height: auto;
              padding: 0;
              border-bottom: none;
              border-right: none;
              font-size: 12px;
              line-height: 21px;
              text-align: left;
              &.reserve-row-date{
                display: inline-block;
              }
              &.reserve-row-name{
                display: inline-block;
                padding-left: 35px;
                background-image: url("../../assets/images/line.png");
                background-repeat: no-repeat;
                background-position: 5px center;
                background-size: 26px 1px;
              }
            }
          }
        }
      }
      .reserve-page{
        width: 180px;
        height: 25px;
        margin: 20px auto 0;
        div{
          border-radius: 3px;
          font-size: 10px;
          line-height: 23px;
        }
      }
    }
    .inside-left-nav{
      display: none;
    }
  }
</style>
